module.exports = __webpack_public_path__ + "img/2.c4d8e467.jpg";